module.exports = __webpack_public_path__ + "fonts/AudiType-WideBold_4.03.75f85545.woff2";